
/**
 * 图片相关的工具接口
 */
import WebPCheck from 'zzc-webp-check';
import * as ZZCImgProcess from 'zzc-img-process';
import {
  isString, isObject
} from '../typeof';
import {
  clone
} from '../object';

/**
 * 对CDN添加图片处理参数
 * @param {string} sourceUrl 图片源URL
 * @param {object} params CDN图片服务处理参数：key => value
 * @returns {string} https://imgcdn1.zuzuche.com/m_tantu_image/20180706/b062a607b389da90f7acb85b6f775c7f.jpg!/both/690x240/format/webp
 */
export function cdn(sourceUrl = '', params) {
  const framents = [];
  Object.keys(params).forEach((key) => {
    const value = params[key];
    framents.push(`/${key}/${value}`);
  });

  const url = sourceUrl.indexOf('imgcdn') !== -1 ? `${sourceUrl}!${framents.join('')}` : sourceUrl;

  return url;
}


const RE_CDN_DOMAIN = /imgcdn(\d+).zuzuche.com/;

// ios原生暂时无法实现wk下的webp方案
// const isWKWebview = !isUndefined(window.webkit);

export function isSupportHttpsImg(url) {
  return url && RE_CDN_DOMAIN.test(url);
}

const handlePoiImageDomain = (url, options) => {
  const START_PARAM = '!/';
  if (url.indexOf(START_PARAM) > -1) {
    // 2. 处理地址上的，转化为object
    const urlQueryParam = ZZCImgProcess.parse(url);

    Object.keys(options).forEach((name) => {
      if (
        name !== 'format'
        || options[name] !== 'webp'
      ) {
        urlQueryParam[name] = options[name];
      }
    });

    // 3. 移除url上，补上合并的
    return ZZCImgProcess.clean(url) + ZZCImgProcess.stringify(urlQueryParam);
  }

  return url + ZZCImgProcess.stringify(options);
};

export function imgUrlTransform(url, options) {
  // 针对 poi-img.tantu.com 单独处理
  if (url && url.indexOf('poi-img.tantu.com') > -1) {
    return handlePoiImageDomain(url, options);
  }

  let imgHandleOptions = {};
  if (isString(options)) {
    imgHandleOptions = ZZCImgProcess.parse(options);
  } else if (isObject(options)) {
    imgHandleOptions = clone(options);
  }
  // if (!isWKWebview && isSupportWebP()) {
  //   imgHandleOptions.format = 'webp';
  // }
  url = resloveUrl(url);
  return ZZCImgProcess.append(url, imgHandleOptions);
}

/**
 * 获取最原本的图片url，如果有其他裁剪参数，切掉
 * @param {*} url
 */
function resloveUrl(url) {
  const checkImg = isSupportHttpsImg(url);
  if (checkImg) {
    if (url.indexOf('.jpg!/') > -1) {
      url = `${url.split('.jpg!/')[0]}.jpg`;
    }
  }
  return url;
}

export const isSupportWebP = WebPCheck;
export const ImgProcess = ZZCImgProcess;
